// extracted by mini-css-extract-plugin
export var error = "textArea_error__n7KlF";
export var formTextArea = "textArea_formTextArea__wM7jV";
export var formTextAreaLabel = "textArea_formTextAreaLabel__RIKkb";
export var formTextAreaSpan = "textArea_formTextAreaSpan__H2aKQ";
export var formTextAreaSpanError = "textArea_formTextAreaSpanError__B9ltl";